export default function startTime() {
  var today = new Date();

  document.getElementById('clock').innerHTML = today.toLocaleTimeString('en-GB', { timeZone: 'Europe/London' });
  return setTimeout(function() {
    startTime()
  }, 500);
}


// WEBPACK FOOTER //
// ./scripts/util/startTime.js